function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18 5.686c6.8 0 12.314 5.513 12.314 12.314 0 6.8-5.513 12.314-12.314 12.314C11.2 30.314 5.686 24.8 5.686 18 5.686 11.2 11.2 5.686 18 5.686zm-.505 5.096c-2.445 0-5.166 1.527-5.166 4.364 0 5.41 8.066 3.468 8.066 6.604 0 .83-1.075 1.61-2.411 1.61-2.184 0-4.351-1.345-5.541-3.087v2.887c1.255 1.145 3.553 2.058 5.54 2.058 3.57 0 5.688-2.589 5.688-4.812 0-5.509-8.197-3.153-8.197-6.504 0-.797.717-1.477 1.972-1.477 2.216 0 4.107 1.211 5.361 2.588v-2.406a8.494 8.494 0 00-5.312-1.825z",
  fill: "#98AAB3",
  fillRule: "nonzero"
});

var SvgCityTrain = function SvgCityTrain(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCityTrain, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cityTrain.7e80b574.svg";
export { ForwardRef as ReactComponent };